import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_RFND3_ND: TStep[] = [
  {
    pageId: PageId.SEX_RFND3_ND,
  },
  {
    pageId: PageId.DOG_AGE_RFND3_ND,
  },
  {
    pageId: PageId.DOG_BREED_RFND3_ND,
  },
  {
    pageId: PageId.URGE_RFND3_ND,
  },
  {
    pageId: PageId.COMMANDS_61_RFND3_ND,
  },
  {
    pageId: PageId.COMMANDS_62_RFND3_ND,
  },
  {
    pageId: PageId.COMMANDS_63_RFND3_ND,
  },
  {
    pageId: PageId.URGE_RFND3_2_ND,
  },
  {
    pageId: PageId.POTTY_RFND3_ND,
  },
  {
    pageId: PageId.BEHAVIOR_RFND3_ND,
  },
  {
    pageId: PageId.TRAINING_RFND3_ND,
  },
  {
    pageId: PageId.PREPARE_FLOW_RFND3_ND,
  },
  {
    pageId: PageId.DOG_STATISTICS_RFND3_ND,
  },
  {
    pageId: PageId.EMAIL_RFND3_ND,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_RFND3_ND,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_RFND3_ND,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_RFND3_ND,
  },
  {
    pageId: PageId.CANCEL_OFFER_RFND3_ND,
  },
  {
    pageId: PageId.CHAT_UPSELL_RFND3_ND,
  },
  {
    pageId: PageId.UPSELL_RFND3_ND,
  },
  {
    pageId: PageId.DOWNLOAD_RFND3_ND,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_RFND3_ND.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_RFND3_ND.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
